import SlimSelect from "slim-select";

const DESTINATION_SELECTOR = ".woocommerce-single-product-summary-details";

class Variables {
  private readonly variableSelects: Array<HTMLSelectElement> = [...document.querySelectorAll<HTMLSelectElement>(".variable-select")];
  private readonly variationsForm = document.querySelector(".variations_form") as HTMLFormElement;
  private readonly destinationElement = document.querySelector(DESTINATION_SELECTOR) as HTMLElement;

  constructor() {}

  init = async (): Promise<void> => {
    if (this.variableSelects.length === 0) return;

    this.disableAddToCart();
    this.moveSelects();
    this.priceUpdate();
    this.descriptionUpdate();
    this.availabilityUpdate();

    window.addEventListener("product_hot_reload", () => {
      this.init();
      window.removeEventListener("product_hot_reload", () => {});
    });
  };

  disableAddToCart = async () => {
    const addToCartButton = document.querySelector(".single_add_to_cart_button") as HTMLButtonElement;

    jQuery("input.variation_id").val() === "0" ? (addToCartButton.disabled = true) : (addToCartButton.disabled = false);

    jQuery("input.variation_id").change(() => {
      const val = jQuery("input.variation_id").val() as string;

      if (val.length > 0) {
        addToCartButton.disabled = false;
      } else {
        addToCartButton.disabled = true;
      }
    });
  };

  moveSelects = async () => {
    const selectsContainer = document.createElement("div");
    selectsContainer.classList.add("variables-selects-container");

    this.variableSelects.forEach((oldSelect) => {
      const newSelectContainer = document.createElement("div");
      newSelectContainer.classList.add("variables-select-container");

      const newSelect = document.createElement("select");
      //copy options from oldSelect to newSelect
      for (let i = 0; i < oldSelect.options.length; i++) {
        newSelect.options[i] = new Option(oldSelect.options[i].text, oldSelect.options[i].value);
      }
      //copy attributes from oldSelect to newSelect
      for (let i = 0; i < oldSelect.attributes.length; i++) {
        newSelect.setAttribute(oldSelect.attributes[i].name, oldSelect.attributes[i].value);
      }

      newSelect.id = `custom-select-${oldSelect.id}`;

      const newSelectLabel = document.createElement("label");
      const newSelectLabelContainer = document.createElement("div");
      newSelectLabelContainer.classList.add("variables-select-label-container");

      const oldLabel = document.querySelector(`label[for="${oldSelect.id}"]`) as HTMLLabelElement;
      newSelectLabel.innerText = oldLabel.innerText;
      newSelectLabel.setAttribute("for", newSelect.id);

      newSelectLabelContainer.appendChild(newSelectLabel);

      if ((oldLabel.dataset.hint as string).length > 0) {
        const hint = document.createElement("div");
        hint.classList.add("hint");

        hint.addEventListener("mouseenter", () => {
          hintPopup.classList.add("active");
        });

        hint.addEventListener("mouseleave", () => {
          hintPopup.classList.remove("active");
        });

        const hintPopup = document.createElement("div");
        hintPopup.classList.add("hint-popup");
        hintPopup.innerText = oldLabel.dataset.hint as string;

        hint.appendChild(hintPopup);
        newSelectLabelContainer.appendChild(hint);
      }

      newSelectContainer.appendChild(newSelectLabelContainer);
      newSelectContainer.appendChild(newSelect);
      selectsContainer.appendChild(newSelectContainer);

      new SlimSelect({
        select: newSelect,
        settings: {
          showSearch: false,
        },
        events: {
          afterChange: () => {
            newSelect.dispatchEvent(new CustomEvent("change", { bubbles: true }));
          },
        },
      });

      newSelect.addEventListener("change", (e) => {
        oldSelect.value = newSelect.value;
        oldSelect.dispatchEvent(new CustomEvent("change", { bubbles: true }));
      });
    });

    this.destinationElement.appendChild(selectsContainer);
  };

  priceUpdate = async () => {
    const priceContainer = document.querySelector(".woocommerce-product-details__price") as HTMLElement;
    const defaultPrice = priceContainer.querySelector(".woocommerce-product-details__price--variable") as HTMLElement;
    const specifiedPrice = priceContainer.querySelector(".woocommerce-product-details__price--specified-variable") as HTMLElement;

    jQuery("input.variation_id").change(() => {
      const val = jQuery("input.variation_id").val() as string;
      const variationPrice = document.querySelector(".woocommerce-variation-price") as HTMLElement;

      if (!variationPrice) return;

      if (val.length > 0) {
        defaultPrice.classList.add("hidden");
        specifiedPrice.innerHTML = variationPrice.innerHTML;
        specifiedPrice.classList.remove("hidden");
      } else {
        specifiedPrice.classList.add("hidden");
        defaultPrice.classList.remove("hidden");
      }
    });
  };

  descriptionUpdate = async () => {
    const descriptionContainer = document.querySelector(".woocommerce-product-details__short-description") as HTMLElement;
    const defaultDescription = descriptionContainer.querySelector(".default-description") as HTMLElement;
    const specifiedDescription = descriptionContainer.querySelector(".variable-description") as HTMLElement;

    jQuery("input.variation_id").change(() => {
      const val = jQuery("input.variation_id").val() as string;
      const variationDescription = document.querySelector(".woocommerce-variation-description") as HTMLElement;

      if (!variationDescription) return;

      if (val.length > 0 && variationDescription.innerHTML.length > 0) {
        defaultDescription && defaultDescription.classList.add("hidden");
        specifiedDescription.innerHTML = variationDescription.innerHTML;
        specifiedDescription.classList.remove("hidden");
      } else {
        specifiedDescription.classList.add("hidden");
        defaultDescription && defaultDescription.classList.remove("hidden");
      }
    });
  };

  availabilityUpdate = async () => {
    const availabilityContainer = document.querySelector(".woocommerce-product-details__details--value") as HTMLElement;
    const defaultAvailability = availabilityContainer.querySelector(".default-availability") as HTMLElement;
    const specifiedAvailability = availabilityContainer.querySelector(".variable-availability") as HTMLElement;

    jQuery("input.variation_id").change(() => {
      const val = jQuery("input.variation_id").val() as string;
      const variationAvailability = document.querySelector(".woocommerce-variation-availability") as HTMLElement;

      if (!variationAvailability) return;

      if (val.length > 0) {
        defaultAvailability.classList.add("hidden");
        specifiedAvailability.innerHTML = variationAvailability.innerHTML;
        specifiedAvailability.classList.remove("hidden");
      } else {
        specifiedAvailability.classList.add("hidden");
        defaultAvailability.classList.remove("hidden");
      }

      const addToCart = document.querySelector(".single_add_to_cart_button") as HTMLButtonElement;

      if (variationAvailability.querySelector(".out-of-stock")) {
        addToCart.disabled = true;
      } else {
        addToCart.disabled = false;
      }
    });
  };
}

export default Variables;
